<template>
  <v-card class="create-rbu">
    <v-card-title>
      Create ASor Rbu Item
      <!-- {{ title }} -->
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field
          outlined
          dense
          :label="'Item No.'"
          v-model="result.item_no"
          :rules="requiredRules"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && save()"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "NewASorRbuItemDialog",
  props: {
    a_sor_id: String,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
      (value) =>
        (!!value && !!value.match(/^\d+(\.\d+)?[A-L]$/)) ||
        `Item No. must ends with [A-L]`,
    ]);

    const result = ref({
      asor_id: props.a_sor_id,
      item_no: "",
    });

    const save = async function () {
      if (!result.value.item_no) return;
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/create_rbu_item/",
        params: {
          ...result.value,
        },
      });

      if (response.body.success) {
        emit("submit", response.body.item_no);
      }
    };

    return {
      requiredRules,
      result,
      save,
      props,
    };
  },
};
</script>
